import { combineReducers } from 'redux'
import product from './product'

const app = combineReducers({
  product,
})

export default app
